export default "__VITE_ASSET__DIJ2ySfV__"